import { MigrationPage } from "../MigrationPage";

const Admin = () => <MigrationPage title="Admin" pageType="Admin" />;

export default Admin;
